import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

import { css } from "../../../lib/theming/Emotion";
export var styles = {
  icon: function icon(t) {
    return css(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n      cursor: pointer;\n      color: ", ";\n    "])), t.dateInputIconColor);
  },
  iconSmall: function iconSmall(t) {
    return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n      font-size: ", ";\n    "])), t.inputFontSizeSmall);
  },
  iconMedium: function iconMedium(t) {
    return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n      font-size: ", ";\n    "])), t.inputFontSizeMedium);
  },
  iconLarge: function iconLarge(t) {
    return css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n      font-size: ", ";\n    "])), t.inputFontSizeLarge);
  },
  iconDisabled: function iconDisabled(t) {
    return css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteralLoose(["\n      cursor: default;\n      color: ", ";\n    "])), t.textColorDisabled);
  }
};